import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-step-btns',
  templateUrl: './step-btns.component.html',
  styleUrls: ['./step-btns.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StepBtnsComponent {
  @Output() stepClick = new EventEmitter<any>();
  @Output() closePage = new EventEmitter<void>();
  @Output() activate = new EventEmitter<void>();
  @Output() deactivate = new EventEmitter<void>();

  @Input() steps;
  @Input() activeStep;
  @Input() isActivateBtnsVisible = false;
  @Input() isActivateBtnVisible = false;
  @Input() isDeactivateBtnsVisible = false;
  @Input() canActivate = false;
  /* Tooltip for the Activate button. Defaults to describing the POS state; a host that gates canActivate
     should pass the prerequisite that is missing instead, since that is what the user needs to read. */
  @Input() activateTooltip = 'pos_dashboard.pos_is_not_active';
  @Input() isStepDisabled: Function;
  @Input() translationPrefix: string = 'global';
  /* Per-step translation-key overrides, for a step whose label depends on the record being edited
     rather than on the step alone. Steps left out of the map keep the derived prefix.step key. */
  @Input() stepLabels: Record<string, string> = {};

  stepLabel(step: string): string {
    return this.stepLabels?.[step] ?? `${this.translationPrefix}.${step}`;
  }

  setActiveStep(step) {
    this.stepClick.emit(step);
  }

  // isStepDisabled(step) {

  // }

  onClose() {
    this.closePage.emit();
  }

  onActivate() {
    this.activate.emit();
  }

  onDeactivate() {
    this.deactivate.emit();
  }
}
